import { FOLLOW_UP_SHORT_LABEL } from "shared/app/CallFollowUp";
import type { Conversation } from "../types";

export const conversationFollowUpLabel = (
  conversation: Pick<Conversation, "follow_up_reason">
): string =>
  conversation.follow_up_reason
    ? FOLLOW_UP_SHORT_LABEL[conversation.follow_up_reason]
    : "Needs follow-up";
